import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button } from '@node-space/ui-components'

export interface AddCustomerActionsProps {
  isLoadingConfirm?: boolean
  isDisableContinue?: boolean
  onConfirmDetails?: () => void
  onCancel: () => void
}

export const AddCustomerActions = ({
  isLoadingConfirm,
  isDisableContinue,
  onConfirmDetails,
  onCancel,
}: AddCustomerActionsProps) => {
  const { t } = useTranslation()

  return (
    <Box flex justify="between" paddingT={24}>
      <Button onClick={onCancel} variant="secondary" disabled={isLoadingConfirm}>
        {t('cancel')}
      </Button>
      {onConfirmDetails ? (
        <Button onClick={onConfirmDetails} loading={isLoadingConfirm}>
          {t('confirm')}
        </Button>
      ) : (
        <Button type="submit" disabled={isDisableContinue}>
          {t('continue')}
        </Button>
      )}
    </Box>
  )
}
